<template>
    <DefaultLayout :title="user.name">

        <template #title>
            <InertiaLink :href="$route('admin::users.index')">{{ __('admin::users.users') }}</InertiaLink>
            <ChevronRightIcon class="w-6 h-6 inline align-text-top text-gray-300" />
            {{ user.name }}
        </template>

        <template #default>

            <Tabs
                class="mb-5"
                :items="[
                    { key: 'general', name: __('admin::users.tab_general'), href: $route('admin::users.general.edit', { user: user.id }) },
                    { key: 'permissions', name: __('admin::users.tab_permissions'), href: $route('admin::users.permissions.index', { user: user.id }) },
                    { key: 'documents', name: __('admin::users.tab_documents'), href: $route('admin::users.documents.index', { user: user.id }) },
                    { key: 'vacations', name: __('admin::users.tab_vacation'), href: $route('admin::users.vacations.index', { user: user.id }) },
                    { key: 'activity-log', name: __('admin::users.activity_log'), href: $route('admin::users.activity-log.index', { user: user.id }) },
                ]"
                :current="currentTab"
            />

            <slot />

        </template>

    </DefaultLayout>
</template>

<script>
import { ChevronRightIcon } from "@heroicons/vue/outline";

export default {
    components: {
        ChevronRightIcon,
    },
    props: {
        user: Object,
        currentTab: String,
    },
}
</script>
